export default __webpack_public_path__ + "static/media/Bugs - 4095.b5ac8867.jpeg";